module.exports = __webpack_public_path__ + "img/education-icon.35b2c78a.svg";